import { css } from 'lit';

/**
 * Makes a badge that is also a link render white text, for tables that pass `customStyles` into
 * <webmodule-table>'s shadow root.
 *
 * Why this keeps being needed: the table component colours every in-cell link with
 * `.wm-table-content .wm-table-cell a`, specificity (0,2,1). That beats its own `.badge` (0,1,0)
 * and even `a.badge` (0,1,1), so a clickable badge renders link-blue text on a coloured chip -
 * legible in DevTools' computed styles, unreadable on screen. Matching the same selector and
 * adding `.badge` gives (0,3,1), which wins without `!important`.
 *
 * Both shapes are covered: the badge ON the anchor, and the badge on a span INSIDE the anchor.
 * The second only breaks when a rule sets the anchor's colour and the span merely inherits it,
 * but tables mix both structures and a reader should not have to work out which is safe.
 */
export const inCellBadgeLinkStyles = css`
  .wm-table-content .wm-table-cell a.badge,
  .wm-table-content .wm-table-cell a .badge {
    color: var(--white);
  }
`;
